import { useState } from "react";

import {
  SampleCycleHistoryTable,
  SampleDataOverlay,
} from "./DiscoveryHubSampleState";
import { formatDiscoveryHubDate } from "./pollAccordionHelpers";
import PollHistoryModals from "./PollHistoryModals";
import Button from "../../Components/Button";
import {
  DH_CYCLE_HISTORY_CARD,
  DH_CYCLE_HISTORY_TABLE_WRAP,
  POLL_HISTORY_ACTION_BTNS,
  POLL_HISTORY_ACTIONS,
  POLL_HISTORY_SUBNAME,
  POLL_HISTORY_TABLE,
} from "../../Utils/Helper/discoveryHubUi";

export type CycleHistoryRow = {
  id: string;
  period: string;
  name?: string | null;
  polls_run?: string | null;
  poll1_done?: number | null;
  poll1_total?: number | null;
  publication_state?: string | null;
  published_at?: string | null;
  reviewed_at?: string | null;
  reviewed_by_name?: string | null;
};

type CycleHistoryPanelProps = {
  rows: CycleHistoryRow[];
};

const CycleHistoryPanel = ({ rows }: CycleHistoryPanelProps) => {
  const [modalRow, setModalRow] = useState<CycleHistoryRow | null>(null);
  const [modalType, setModalType] = useState<
    "responses" | "leaderboard" | null
  >(null);

  const openModal = (
    row: CycleHistoryRow,
    type: "responses" | "leaderboard"
  ) => {
    setModalRow(row);
    setModalType(type);
  };

  const closeModal = () => {
    setModalRow(null);
    setModalType(null);
  };

  if (rows.length === 0) {
    return (
      <SampleDataOverlay message="Preview of poll history — approved polls appear here after the leaderboard is published.">
        <SampleCycleHistoryTable />
      </SampleDataOverlay>
    );
  }

  return (
    <>
      <div className={DH_CYCLE_HISTORY_CARD}>
        <div className={DH_CYCLE_HISTORY_TABLE_WRAP}>
          <table className={POLL_HISTORY_TABLE}>
            <thead>
              <tr>
                <th>Quarter</th>
                <th>Polls run</th>
                <th>Poll 1 completion</th>
                <th>Published on</th>
                <th>Approver</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(row => {
                const done = row.poll1_done ?? 0;
                const total = row.poll1_total ?? 0;

                return (
                  <tr key={row.id}>
                    <td>
                      <strong>{row.period}</strong>
                      {row.name && row.name !== row.period ? (
                        <div className={POLL_HISTORY_SUBNAME}>{row.name}</div>
                      ) : null}
                    </td>
                    <td>{row.polls_run || "—"}</td>
                    <td className="tabular-nums">
                      {total > 0 ? `${done}/${total}` : "—"}
                    </td>
                    <td>
                      {formatDiscoveryHubDate(
                        row.published_at ?? row.reviewed_at
                      )}
                    </td>
                    <td>{row.reviewed_by_name || "—"}</td>
                    <td className={POLL_HISTORY_ACTIONS}>
                      <div className={POLL_HISTORY_ACTION_BTNS}>
                        <Button
                          variant="secondary"
                          className="text-xs py-1 px-2"
                          onClick={() => openModal(row, "responses")}
                        >
                          View Responses
                        </Button>
                        <Button
                          variant="secondary"
                          className="text-xs py-1 px-2"
                          onClick={() => openModal(row, "leaderboard")}
                        >
                          View Leaderboard
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <PollHistoryModals
        row={modalRow}
        modal={modalType}
        onClose={closeModal}
      />
    </>
  );
};

export default CycleHistoryPanel;
